const BLOGPARTS_WRAPPER_SELECTOR = "[data-blogparts='root']";
const IFRAME_WRAPPER_CLASSNAME = "iframe-resizer-wrapper";

class IframeResizer {
    static attach(container) {
        const iframeElements = container.querySelectorAll("iframe");
        if (iframeElements) {
            [...iframeElements].forEach((iframeElement) => {
                /* eslint-disable-next-line no-unused-vars */
                const iframeResizer = new IframeResizer(iframeElement);
            });
        }
    }

    constructor(iframeElement) {
        if (!this.isBlogpartsIframe(iframeElement)) {
            this.wrapIframe(iframeElement);
        }
    }

    isBlogpartsIframe = (iframeElement) => {
        return iframeElement.closest(BLOGPARTS_WRAPPER_SELECTOR);
    };

    getIframeDimension = (iframeElement) => {
        const iframeWidth = iframeElement.getAttribute("width") || iframeElement.offsetWidth;
        const iframeHeight = iframeElement.getAttribute("height") || iframeElement.offsetHeight;

        return {
            width: iframeWidth,
            height: iframeHeight,
            ratioPercentage: (iframeHeight / iframeWidth) * 100
        };
    };

    wrapIframe(iframeElement) {
        const { width, ratioPercentage } = this.getIframeDimension(iframeElement);
        const wrapper = document.createElement("div");
        wrapper.classList.add(IFRAME_WRAPPER_CLASSNAME);
        wrapper.style.setProperty("--ratio-percentage", `${ratioPercentage}%`);
        wrapper.style.width = `${width}px`;
        iframeElement.insertAdjacentElement("beforebegin", wrapper);
        wrapper.insertAdjacentElement("afterbegin", iframeElement);
    }
}

export { IframeResizer };
